export const REQUEST_IMPORT_HISTORY = 'REQUEST_IMPORT_HISTORY';
export const RECEIVE_IMPORT_HISTORY = 'RECEIVE_IMPORT_HISTORY';
